/**
* Detail experience revive selector
*
* This function create an selector
*
*/

export const results = (state) => state.detailExperienceReviveReducer;
export const resData = (state) => state.detailExperienceReviveReducer.data.data;
